import { withInstall } from '../../utils/install';
import Input from './index.vue';

export const IvueInput = withInstall(Input);
export default IvueInput;

export * from './index.vue';
